import React from 'react';

import { Box, IconButton } from '@mui/material';
import { ReactComponent as HamburgerMenu } from 'components/layout/assets/hamburger-menu.svg';
import { useLayoutState } from 'components/layout/layout';
import DeliveryBoard from '../delivery-board/delivery-board';
import LandingPage from './components/landing';

type OverviewProps = {};

const Overview: React.FC<OverviewProps> = () => {
  const { handleSidebarToggle, sidebarOpen } = useLayoutState();
  const isDeliveryBoard = location.pathname.split('/')[1] === 'delivery-board';

  return (
    <Box>
      <Box display={{ xs: 'none', md: 'block' }}>
        <IconButton
          onClick={handleSidebarToggle}
          sx={{
            display: sidebarOpen ? 'none' : 'block',
            zIndex: '1',
            top: isDeliveryBoard ? -67 : 20,
            left: isDeliveryBoard ? 0 : 40,
            position: isDeliveryBoard ? 'none' : 'absolute',
          }}
          disableRipple>
          <HamburgerMenu />
        </IconButton>
      </Box>
      {isDeliveryBoard ? <DeliveryBoard /> : <LandingPage />}
    </Box>
  );
};

export default React.memo(Overview);
